import { createFileRoute } from '@tanstack/react-router'
import { useBrandFeatures } from '@/lib/use-brand-features'
import { AuthServerError } from '@/features/auth-server-unavailable'
import { BrandUnavailableError } from '@/features/auth-server-unavailable'
import { Layout } from '@/layout/layout'
import { Content } from '@/layout/content'

export const Route = createFileRoute('/auth-server-unavailable')({
  component: AuthServerUnavailable,
})

function AuthServerUnavailable() {
  const { isAvailableToPlayers } = useBrandFeatures()

  return (
    <Layout>
      <Content backgroundVariant="branded">
        {/* FIXME: Only needed because the login/reg is no available for UNI, remove as soon as they become available */}
        {isAvailableToPlayers ? <AuthServerError /> : <BrandUnavailableError />}
      </Content>
    </Layout>
  )
}
